const VIDEO_EXTENSIONS = /\.(mp4|mov|avi|webm)$/i;

// GCS signed URLs append a query string (?X-Goog-Algorithm=...&X-Goog-Signature=...)
// after the real filename, so the extension is no longer the last characters of
// the URL — strip the query string (and any #fragment) before checking it.
const stripQueryAndFragment = (url) => url.split("?")[0].split("#")[0];

export const isVideoUrl = (url) => {
  if (!url) return false;
  return VIDEO_EXTENSIONS.test(stripQueryAndFragment(url));
};

export const getVideoMimeType = (url) => {
  const path = stripQueryAndFragment(url);
  const extension = path.split(".").pop().toLowerCase();
  // .mov files are QuickTime, not a "video/mov" MIME type browsers recognize.
  return extension === "mov" ? "video/quicktime" : `video/${extension}`;
};
